import React from 'react';

type Props = React.PropsWithChildren<{
  className?: string;
  textColor?: string;
  textSize?: string;
  center?: boolean;
  bold?: boolean;
  whiteSpace?: string;
  fontWeight?: string;
  textAlign?: string;
}>;

export function Text({
  children,
  className = '',
  textColor = 'text-neutral-600',
  textSize,
  center,
  bold,
  fontWeight = bold ? 'font-semibold' : 'font-normal',
  textAlign = center ? 'text-center' : 'text-start',
  whiteSpace = 'whitespace-pre-line',
}: Props) {
  return (
    <p
      className={`${className} 
				${textSize || ''}
				${textColor} 
				${textAlign} 
				${fontWeight}
				${whiteSpace}
			`}
    >
      {children}
    </p>
  );
}
